const divTenantSelector = {
  notActiveBadge: 'Not Activated',
  access: 'You have no assigned company',
  blocked: 'Blocked',
};

export default divTenantSelector;
